const states = [
	'success',
	'error',
	'warning',
	'loading',
];

const setInputState = ( inputEl, state ) => {
	const inputRowEl = inputEl.closest( '.input_row' );
	const wrapperEl = inputEl.closest( '.input_row .input_wrapper' );

	inputRowEl.classList.remove( 'row_has_message' );
	inputRowEl.removeAttribute( 'data-notification' );
	if ( state && inputEl.classList.contains( 'showvalidatesuccess' ) ) {
		inputRowEl.setAttribute( 'data-notification', state );
	}

	if ( wrapperEl ) {
		wrapperEl.removeAttribute( 'data-state' );
		if ( state && wrapperEl.classList.contains( 'input_wrapper--has_stateindicator' ) ) {
			wrapperEl.setAttribute( 'data-state', state );
			wrapperEl.removeAttribute( 'data-notification' );
		} else {
			// Legacy States.
			states.forEach( ( stateClass ) => {
				wrapperEl.classList.toggle( 'has_' + stateClass, stateClass === state );
			} );
		}
	}
	return wrapperEl;
};

const setMessage = ( inputEl, message = false, state = 'error' ) => {
	// Get Input Row.
	const inputRowEl = inputEl.closest( '.input_row' );

	// Elements we manipulate.
	const messageEl = inputRowEl.querySelector( '.input_row_message' );

	// Set Class for Message depending on State.
	if ( messageEl ) {
		messageEl.classList.remove( ...states );
		if ( states.includes( state ) ) {
			messageEl.classList.add( state );
		} else {
			messageEl.classList.add( 'error' );
		}

		// Remove inline style from these errors.
		if ( messageEl.style.display ) {
			messageEl.style.display = null;
		}

		messageEl.dataset.defaultMessage ??= messageEl.innerHTML;
		messageEl.innerHTML = message || messageEl.dataset.defaultMessage;
	}
	// Display the Message.
	inputRowEl.classList.add( 'row_has_message' );
	if ( ! inputEl.classList.contains( 'showvalidatesuccess' ) ) {
		inputRowEl.removeAttribute( 'data-notification' );
	}

	return messageEl;
};

const showError = ( inputEl, message = false, state = 'error' ) => {
	const wrapperEl = setInputState( inputEl, state );
	const messageEl = setMessage( inputEl, message, state ); //eslint-disable-line no-unused-vars

	return [ wrapperEl, messageEl ];
};

const hideError = ( inputEl, state = 'success' ) => {
	const wrapperEl = setInputState( inputEl, state );
	return [ wrapperEl ];
};

const setLoading = ( inputEl, state = 'loading' ) => {
	const wrapperEl = setInputState( inputEl, state );
	return [ wrapperEl ];
};

const resetError = ( inputEl ) => {
	const wrapperEl = setInputState( inputEl, null );
	return [ wrapperEl ];
};

const scrollToFirstError = function( formEl ) {
	let scrollTop = window.scrollY + formEl.getBoundingClientRect().top;

	// Scroll to first message, if available.
	const messageEl = formEl.querySelector( '.row_has_message' );
	if ( messageEl ) {
		scrollTop = window.scrollY + messageEl.getBoundingClientRect().top;
	}

	// Offset Header size.
	const offsetEls = [ document.querySelector( '.mdl_servicerow' ), document.querySelector( '.en_header, .mdl_header__bar' ) ].filter( Boolean );
	offsetEls.forEach( ( offsetEl ) => {
		scrollTop -= offsetEl.offsetHeight;
	} );

	// Add additional small offset.
	scrollTop = Math.max( 0, scrollTop - 20 );

	if ( ! isNaN( scrollTop ) ) {
		document.scrollingElement.scrollTo( {
			top: scrollTop,
			behavior: 'smooth',
		} );
	}
};

export {
	showError,
	hideError,
	setInputState,
	setLoading,
	setMessage,
	resetError,
	scrollToFirstError,
};
